module.exports = __webpack_public_path__ + "img/fieldPlay2.003c74ad.gif";